import Helpers from '../js/helpers';

export default new class Articles {
  constructor() {
    this.articles = 'articles';
    this.$articles = $(`.${this.articles}`);

    if (!this.$articles.length) return;

    this.articlesSide = 'articles__side';
    this.articlesContentList = 'articles__content_list';
    this.newsCard = 'news-card';

    this.init();
  }

  init() {
    if (Helpers.isMobile()) return;

    this.getArticlesSidePosition();
  }

  getArticlesSidePosition() {
    const $articlesSide = $(`.${this.articlesSide}`);
    const $articlesContentList = $(`.${this.articlesContentList}`);
    const $firstNewsCard = $articlesContentList.find(`.${this.newsCard}`).eq(0);
    const $secondNewsCard = $articlesContentList.find(`.${this.newsCard}`).eq(1);
    const $secondNewsCardTop = $secondNewsCard.position() ? $secondNewsCard.position().top : null;
    const margin = 30;

    if (!$firstNewsCard.hasClass('_wide')){
      $articlesSide.css('padding-top', `0`);
    }else {
      $articlesSide.css('padding-top', `${$secondNewsCardTop + margin}px`);
    }
  }
}();
